import { Component, OnInit } from '@angular/core';
import { LiftDetail } from '../../models/lift-detail.model';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../user/services/login.service';

@Component({
  selector: 'app-lift-consumption',
  templateUrl: './lift-consumption.component.html',
  styleUrls: ['./lift-consumption.component.css']
})
export class LiftConsumptionComponent implements OnInit {
  menu = 'consum';
  lift: LiftDetail;
  liftId: number;

  //Permissions
  canViewErrors: boolean = false;
  canView: boolean = false;
  canControl: boolean = false;
  canViewParameter: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private loginService: LoginService
  ) { }

  ngOnInit() {
    this.liftId = +this.route.snapshot.paramMap.get('id');
    this.lift = this.route.snapshot.data.lift;

    let liftPermission = this.route.snapshot.data.liftPermission;
    if (!liftPermission) {
      liftPermission = [];
    }

    this.canViewErrors = liftPermission.indexOf('2') > -1 || this.loginService.isSuperadmin();
    this.canView = liftPermission.indexOf('0') > -1 || this.loginService.isSuperadmin();
    this.canControl = liftPermission.indexOf('3') > -1 || this.loginService.isSuperadmin();
    this.canViewParameter = liftPermission.indexOf('4') > -1 || this.loginService.isSuperadmin();
  }

}
